import { ContactPolicyVersion } from '@vision/ui/enums';

interface ContactPolicyVersionResponseDto {
  data: {
    data?: string;
  };
}

export function fromApiContactPolicyVersion(response: ContactPolicyVersionResponseDto): ContactPolicyVersion {
  return response.data.data === ContactPolicyVersion.V2 ? ContactPolicyVersion.V2 : ContactPolicyVersion.V1;
}
